
    const categoryNav = document.querySelector('.category-nav');
    const categoryButtons = categoryNav.querySelectorAll('[data-btn]');
    const posts = document.querySelectorAll('[data-item]');
    const section = document.querySelector('[data-wrapper]');
    const categoryTags = document.querySelectorAll('[data-category-filter]');

    categoryButtons.forEach(button => {
        button.addEventListener('click', () => {
          console.log(button)
            categoryButtons.forEach(button => button.removeAttribute('data-active'));
            button.setAttribute('data-active', '');
            const category = button.textContent;
            posts.forEach(post => {
                if (category === 'All posts') {
                    post.removeAttribute('data-hidden');
                } else if (post.dataset.category.includes(category)) {
                    post.removeAttribute('data-hidden');
                } else {
                    post.setAttribute('data-hidden', '');
                }
            });
        });
    });

    categoryTags.forEach(tag => {
        tag.addEventListener('click', () => {
            categoryButtons.forEach(button => button.removeAttribute('data-active'));
            const category = tag.textContent;
            posts.forEach(post => {
                if (category === 'All posts') {
                    post.removeAttribute('data-hidden');
                } else if (post.dataset.category.includes(category)) {
                    post.removeAttribute('data-hidden');
                } else {
                    post.setAttribute('data-hidden', '');
                }
            });
            // set data-active on the corresponding category button
            categoryButtons.forEach(button => {
                if (button.textContent === category) {
                    button.setAttribute('data-active', '');
                }
            });
        });
    });
    
